export default __webpack_public_path__ + "67a3ede24f69e2a33043de53bd8d4a74.png";